import React, { Component } from 'react'
import Header from './components/header'
import { HashRouter } from 'react-router-dom'
import AOS from 'aos'
import './app.css'

class App extends Component {
  componentDidMount () {
    AOS.init({
      duration: 2000
    })
  }

  render () {
    return (
      <HashRouter>
        <Header />
      </HashRouter>
    )
  }
}

export default App
// https://www.adamhartwig.co.uk
